export default __webpack_public_path__ + "static/media/menu.4fd58c00.svg";